import React, { useMemo, useState, useEffect } from "react";
import Card from "react-bootstrap/Card";

import DataTable from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import axios from 'axios'
import { API_BASE_PATH } from "../Api";

const Priority=(props)=>{
    const pristr=(p)=>{
        switch(p){
            case 0:
                return "Regular";
            case 1:
                return "CrossSell";
            case 2:
                return "UpSell";
            default:
                return "Other"
        }
    }
    return (
        <>
            <span>{pristr(props.row.skuPriority)}</span>
        </>
    );
};

const RecommendationsTable = props => {
    const ulStyle = { width: '100%', listStyleType: 'none',padding:'0px' }
    const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee',padding:'10px',margin:"10px" }
  
    const columns = [
        
        {
            name: "Outlet Code",
            selector: "outletCode",
            sortable: true,
            hide: "sm"
        },
        {
            name: "LoginId",
            selector: "loginId",
            sortable: true
        },
        {
            name: "BatchCode",
            selector: "batchCode",
            sortable: true
        },
        {
            name: "SKUCode",
            selector: "skuCode",
            sortable: true
        },
        {
            name: "Piece Quantity",
            selector: "pieceQuantity",
            sortable: true,
            hide: "md"
        },
        {
            name: "Amount",
            selector: "totalAmount",
            sortable: true,
            hide: "md"
        },
        {
            name: "Reco..Type",
            button: true,
            width: "140px" ,    
            cell: row =>
                (
                    <Priority row={row}></Priority>
                ) 
        }
        
    ];
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = React.useState(props.outletCode);
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
        false
    );
    const filteredItems = data;
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [summary, setSummary] = useState({
        regular:{q:0,a:0,c:0},
        upsell:{q:0,a:0,c:0},
        crosssell:{q:0,a:0,c:0}
    });
    var userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }
    
    const onDataFilter=val=>{
        setFilterText(val);
        fetchUsers(1,val);
        props.onFilter(val);
    }

    useEffect(() => {
        if(filterText){
            onDataFilter(filterText);
        }
    }, [filterText])
    

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                onDataFilter("");
            }
        };

        return (
            <FilterComponent
                onFilter={e => onDataFilter(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    

    const fetchDataOC=async (page,filter) =>{
        const response = await axios.get(API_BASE_PATH+`/smartbasket/recommendations?outletCode=${filter}&environment=${userInfo.environment||"uat"}&lob=${userInfo.accountId}&page=${page}&count=${10}&resolve=true`);
        setData(response.data.features.sort(function(a, b){return a.skuPriority - b.skuPriority}));
        let count = response.data.features.length;
        setTotalRows(count);

        const upsellItems =response.data.features.filter(a=>a.recommendationType=="extra" && a.skuPriority==2 )
        summary.upsell.a=upsellItems.reduce((a, b) => a + b.totalAmount, 0);
        summary.upsell.q=upsellItems.reduce((a, b) => a + b.pieceQuantity, 0);
        summary.upsell.c=upsellItems.length;

        const crosssellItems =response.data.features.filter(a=>a.recommendationType=="extra" && a.skuPriority==1 )
        summary.crosssell.c=crosssellItems.length;
        summary.crosssell.a=crosssellItems.reduce((a, b) => a + b.totalAmount, 0);
        summary.crosssell.q=crosssellItems.reduce((a, b) => a + b.pieceQuantity, 0);

        const regularItems =response.data.features.filter(a=>a.skuPriority==0 )
        
        summary.regular.a=regularItems.reduce((a, b) => a + b.totalAmount, 0);
        summary.regular.q=regularItems.reduce((a, b) => a + b.pieceQuantity, 0);
        summary.regular.c=regularItems.length;

        setSummary(summary);
        return response.data.features;
    }

    const fetchUsers = async (page,filt) => {
        setLoading(true);
        if(!filt){
            setData([]);
            setTotalRows(0);

        }else{
            await fetchDataOC(page,filt);
        }
        setPerPage(10);
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchUsers(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
    };
    useEffect(() => {
        fetchUsers(1); 
    }, []);

    return (
        <>
{ filterText && 
<Card style={{margin:"10px"}}>
          <Card.Body>
            <Card.Title style={{ color: "green" }}>Summary</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">
            </Card.Subtitle>
            <Card.Text>
  
            </Card.Text>
            <ul style={ulStyle}>
              {/* <li>
                ClusterInfo : {JSON.stringify(recommendations)}
              </li> */}
              
               <li>
                Total Line Count : {data.length} (Regular :{summary.regular.c}  Upsell :{summary.upsell.c}  Crossell :{summary.crosssell.c} )
              </li>
              <li>
                Total Regular Amount : {summary.regular.a} (Quantity {summary.regular.q})
              </li>
              <li>
                Total Upsell Amount : {summary.upsell.a} (Quantity {summary.upsell.q})
              </li>
              <li>
                Total Crossell Amount : {summary.crosssell.a} (Quantity {summary.crosssell.q})
              </li>
             
              <li>
                Total Amount : {data.reduce((a, b) => a + b.totalAmount, 0)}
              </li>

              
            </ul>
          </Card.Body>
        </Card>
}
        <DataTable
            title=""
            columns={columns}
            data={filteredItems}
            progressPending={loading}
            
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponent}
        />

        </>
    );
};




export default RecommendationsTable;
